import { GAME_ID, REDUX_ACTIONS, focusStates } from '../../../data/constants';
import { feedbackTypes, worksheetActionTypes } from '../../../../components/worksheet/data/constants';

const carouselItem = {
  focusable: true,
  focused: focusStates.NEUTRAL,
  poppedUp: false,
  feedback: feedbackTypes.NONE,
  isAnimatingToDrawAttention: false,
  isCorrect: false,
};

const initialState = {
  items: [],
  progressInReveal: 0,
  interactionsEnabled: false,
  isVisible: false,
  correctIndex: 0,
  incorrectChoicesMade: 0,
  isCarouselAppearanceBeingBlocked: false,
  isRenderingAnswerChoices: true,
};

const carouselReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_CAROUSEL_ITEM_COUNT: {
      const { count, poppedUp } = payload;
      const items = [];
      for (let i = 0; i < count; i++) {
        items.push({ ...carouselItem, poppedUp });
      }
      return {
        ...state,
        items,
        progressInReveal: 0,
        incorrectChoicesMade: 0,
      };
    }

    case REDUX_ACTIONS.SET_CAROUSEL_VISIBLE:
      return {
        ...state,
        isVisible: payload,
      };

    case REDUX_ACTIONS.SET_IS_RENDERING_ANSWER_CHOICES:
      return {
        ...state,
        isRenderingAnswerChoices: payload,
      };

    case REDUX_ACTIONS.INIT_STANDARD_ITEM:
      return {
        ...state,
        isRenderingAnswerChoices: true, // we probably don't want to keep answer choices disabled across multiple items.
      };

    case REDUX_ACTIONS.SET_CAROUSEL_CORRECT_INDEX:
      return {
        ...state,
        correctIndex: payload,
      };

    case REDUX_ACTIONS.SET_CAROUSEL_ITEM_FOCUSED: {
      const items = [...state.items];
      const { index, focused } = payload;
      items[index] = {
        ...items[index],
        focused,
      };

      return {
        ...state,
        items,
      };
    }

    case REDUX_ACTIONS.POPUP_CAROUSEL_ITEM: {
      const items = [...state.items];
      items[payload] = {
        ...items[payload],
        poppedUp: true,
      };

      return {
        ...state,
        items,
        progressInReveal: payload + 1,
      };
    }

    case REDUX_ACTIONS.SET_CAROUSEL_INTERACTIONS_ENABLED:
      return {
        ...state,
        interactionsEnabled: payload,
      };

    case worksheetActionTypes.ON_INCORRECT_START:
    case worksheetActionTypes.ON_CORRECT_START: {
      const items = [...state.items];
      const { index } = payload;
      items[index] = {
        ...items[index],
        feedback: type === worksheetActionTypes.ON_CORRECT_START ? feedbackTypes.CORRECT : feedbackTypes.INCORRECT,
      };
      const interactionsEnabled = false; // lock interactions when you start any kind of feedback

      return {
        ...state,
        items,
        interactionsEnabled,
      };
    }

    case worksheetActionTypes.ON_INCORRECT_END: {
      let items = [...state.items];
      const { index } = payload;
      items[index] = {
        ...items[index],
        focusable: false,
      };

      // after two incorrect choices, disable all remaining incorrect choices.
      const { incorrectChoicesMade, correctIndex } = state;
      if (incorrectChoicesMade + 1 >= 2) {
        items = disableInteractionsOnIncorrectOptions(items, correctIndex);
      }

      return {
        ...state,
        interactionsEnabled: true,
        incorrectChoicesMade: incorrectChoicesMade + 1,
        items,
      };
    }

    case REDUX_ACTIONS.DISABLE_INCORRECT_CAROUSEL_OPTIONS:
      return {
        ...state,
        items: disableInteractionsOnIncorrectOptions(state.items, state.correctIndex),
      };

    case REDUX_ACTIONS.SET_BLOCKING_CAROUSEL_APPEARANCE:
      return {
        ...state,
        isCarouselAppearanceBeingBlocked: payload,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export const disableInteractionsOnIncorrectOptions = (itemList, correctIndex) => {
  const items = [...itemList];
  for (let i = 0; i < items.length; i++) {
    if (i !== correctIndex) { // make incorrect items un-focusable
      if (items[i].focusable) {
        items[i] = {
          ...items[i],
          focusable: false,
        };
      }
    } else { // make the crrect item start animating to draw attention to itsself.
      items[i] = {
        ...items[i],
        isCorrect: true,
        isAnimatingToDrawAttention: true,
      };
    }
  }
  return items;
};

export default carouselReducer;
